import Timeline from "@/components/Timeline.vue";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
import { builderCta } from "@/helpers/builder-init/index";
import * as themeColors from "@assets/styles/colors.module.scss";
import { strippedCta } from "@/helpers/builder-init/index";
const { hasValue } = useBuilderShowIf();
const colors = ["None", ...Object.keys(themeColors)];

export const timelineInit = {
    component: Timeline,
    name: "Timeline",
    inputs: [
         {
            name: "layout",
            friendlyName: "Layout and Orientation",
            type: "object",
            subFields: [
                    {
                        name: "scrollBarPosition",
                        friendlyName: "Scroll Bar Position",
                        type: "string",
                        enum: ["left", "right"]
                    },
            ]
        },
        {
            name: "action",
            friendlyName: "Actions Panel",
            type: "object",
            subFields: [
                {
                    name: "bgColor",
                    friendlyName: "Background Color",
                    type: "string",
                    enum: colors
                },
                {
                    name: "continueText",
                    friendlyName: "Continue Text",
                    type: "object",
                    subFields: [
                        {
                            name: "label",
                            friendlyName: "Label",
                            type: "string",
                            default: ""
                        },
                        {
                            name: "color",
                            friendlyName: "Font Color",
                            type: "string",
                            enum: colors
                        },
                        {
                            name: "aria_label",
                            friendlyName: "Aria Label",
                            type: "string",
                            default: ""
                        },
                    ]
                },
                {       
                    name: 'skip',
                    type: 'object',
                    subFields: strippedCta(['aria_label', 'style', 'label']).subFields
                },
            ]
        },
        {
            name: "timelineData",
            friendlyName: "Timeline",
            type: "array",
            default: {},
            subFields: [
                {
                    name: "title",
                    friendlyName: "Title",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            friendlyName: "Text",
                            type: "string",
                            default: ""
                        },
                        {
                            name: "color",
                            friendlyName: "Font Color",
                            type: "string",
                            enum: colors,
                            default: "",
                            showIf: hasValue("text")
                        }
                    ]
                },
                {
                    name: "subtitle",
                    friendlyName: "SubTitle",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            friendlyName: "Text",
                            type: "string",
                            default: ""
                        },
                        {
                            name: "color",
                            friendlyName: "Font Color",
                            type: "string",
                            enum: colors,
                            default: "",
                            showIf: hasValue("text")
                        }
                    ]
                },
                {
                    name: "description",
                    friendlyName: "Description",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            friendlyName: "Text",
                            type: "richText",
                            default: ""
                        },
                        {
                            name: "color",
                            friendlyName: "Font Color",
                            type: "string",
                            enum: colors,
                            default: "",
                            showIf: hasValue("text")
                        }
                    ]
                },
                {
                    name: "image",
                    friendlyName: "Image",
                    type: "object",
                    subFields: [
                        {
                            name: "media",
                            friendlyName: "Media",
                            allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                            type: "file",
                            defaultValue: ""
                        },
                        {
                            name: "alt",
                            friendlyName: "Alt Text",
                            type: "string",
                            defaultValue: ""
                        },
                    ]
                },
                {
                    name: "cta",
                    friendlyName: "CTA",
                    type: "object",
                    defaultValue: builderCta.defaultValue,
                    subFields: [...builderCta.subFields]
                },
                {
                    name: "image_alignment",
                    friendlyName: "Image Alignment",
                    type: "string",
                    enum: ["left", "right"]
                },
                {
                    name: "bgColor",
                    friendlyName: "Background Color",
                    type: "string",
                    enum: colors,
                },
            ]
        },

    ]
};
